import { render, staticRenderFns } from "./PublicacionesEditar.vue?vue&type=template&id=86f18430&"
import script from "./PublicacionesEditar.vue?vue&type=script&lang=js&"
export * from "./PublicacionesEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports